import { useState, useCallback } from 'react';
import * as herdsmanManagementAction from "../../../redux/store-sarang/herdsman/herdsman-management.store";
import * as accountManagementAction from "../../../redux/store/account/account.store";
import ShowNotification from "../../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../../utils/configuration";
import viVN from "../../../language/vi-VN.json";

export const useHerdsmanData = (showLoading, configLocal, setValue, fetchFunction = herdsmanManagementAction.GetListHerdsman) => {
    const [data, setData] = useState([]);
    const [totalItemCount, setTotalItemCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(configLocal.defaultPageSize);
    const [order, setOrder] = useState(configLocal.order);
    const [orderBy, setOrderBy] = useState(configLocal.orderBy);
    const [searchData, setSearchData] = useState();

    const getListHerdsmanManagement = useCallback(async (pageIndex = 1, pageSize = configLocal.defaultPageSize, sortExpression = configLocal.sortExpression, searchData = undefined) => {
        showLoading(true);
        try {
            const res = await fetchFunction(pageIndex, pageSize, sortExpression, searchData);

            if (res && res.content && res.content.items) {
                setData(res.content.items);
                setTotalItemCount(res.content.totalItemCount);
            }
        } catch (err) {
            if (err && err.errorType) {
                ShowNotification(
                    viVN.Errors[err.errorType],
                    NotificationMessageType.Error
                );
            }
        } finally {
            showLoading(false);
        }
    }, [showLoading, configLocal]);

    const getUserDetail = useCallback(async () => {
        try {
            const res = await accountManagementAction.GetDetailAcc();
            if (res && res.content) {
                const branchId = res.content.branchId;
                if (branchId) {
                    setValue("branchId", branchId, { shouldValidate: true });
                    setSearchData({ branchId });
                    getListHerdsmanManagement(1, rowsPerPage, configLocal.sortExpression, { branchId });
                    return;
                }
            }
            getListHerdsmanManagement();
        } catch (err) {
            getListHerdsmanManagement();
        }
    }, [rowsPerPage, getListHerdsmanManagement, setValue, configLocal.sortExpression]);

    return {
        data, setData,
        totalItemCount, setTotalItemCount,
        page, setPage,
        rowsPerPage, setRowsPerPage,
        order, setOrder,
        orderBy, setOrderBy,
        searchData, setSearchData,
        getListHerdsmanManagement,
        getUserDetail
    };
};
